import React from 'react';
import { connect } from 'react-redux';
import FooterSectionView from './footer-section-view';
import {
  createSectionLinkT,
  removeFooterSectionT,
  removeSectionLinkT,
  setLinkTitleT, setLinkUriT,
  setSectionLinksT,
  setSectionTitleT
} from "../../../../../state/actions/shared/section";

const FooterSectionRedux = (props) => (
  <FooterSectionView {...props}/>
);

const mapStateToProps = (state, ownProps) => {
  const {id:sectionId, index:sectionIndex} = ownProps;
  const guideEntities = state.guides.guide;
  const {sections} = guideEntities;
  const currentSection = sections[sectionId];
  const {title, links} = currentSection || {};
  return{
    index: sectionIndex,
    title,
    links: links || [],
    id: sectionId,
    readOnly: state.versions.readOnly,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const {guideId, id:sectionId} = ownProps;
  const defaultLink = {title: '', uri: ''};
  return {
    onDeleteSection: () => dispatch(removeFooterSectionT('guide', guideId, sectionId)),
    onTitleChange: (text) => dispatch(setSectionTitleT('guide', sectionId, text)),
    onAddLink: () => dispatch(createSectionLinkT('guide', sectionId, defaultLink)),
    onLinkTitleChange: (linkId, text) => dispatch(setLinkTitleT('guide', sectionId, linkId, text)),
    onLinkUriChange : (linkId, text) => dispatch(setLinkUriT('guide', sectionId, linkId, text)),
    onLinkOrderChange: (list) => dispatch(setSectionLinksT('guide', sectionId, list)),
    onDeleteLink: (linkId) => dispatch(removeSectionLinkT('guide', sectionId, linkId)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FooterSectionRedux);
